import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { NAV_MAIN, NAV_AREE } from "../../data/site";
import BookCta from "../BookCta";

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkClass = ({ isActive }) =>
    `text-sm font-medium transition-colors duration-200 ${
      isActive ? "text-gold-light" : "text-slate-200 hover:text-white"
    }`;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-white/10 bg-navy text-white"
    >
      <div className="container-site flex h-16 sm:h-20 items-center justify-between gap-3">
        <Link
          to="/"
          data-testid="brand-logo-link"
          className="flex items-center gap-2.5 sm:gap-3"
          aria-label="Studio Legale Avv. Manfredi Bruno - Home"
        >
          <span className="flex h-9 w-9 sm:h-10 sm:w-10 shrink-0 items-center justify-center border border-gold/60 font-serif text-base sm:text-lg font-semibold text-gold">
            MB
          </span>
          <span className="leading-tight">
            <span className="block whitespace-nowrap font-serif text-[15px] sm:text-lg font-semibold">
              Avv. Manfredi Bruno
            </span>
            <span className="block whitespace-nowrap text-[9px] sm:text-[11px] uppercase tracking-[0.14em] sm:tracking-[0.18em] text-slate-300">
              Lavoro e previdenza
            </span>
          </span>
        </Link>

        <nav data-testid="desktop-nav" className="hidden lg:flex items-center gap-7" aria-label="Navigazione principale">
          <div className="group relative">
            <button
              type="button"
              data-testid="nav-aree-dropdown-trigger"
              className="flex items-center gap-1 text-sm font-medium text-slate-200 transition-colors hover:text-white"
              aria-haspopup="true"
            >
              Aree di attività <ChevronDown size={14} aria-hidden="true" />
            </button>
            <div className="invisible absolute left-0 top-full w-64 pt-3 opacity-0 transition-all duration-200 group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
              <div className="rounded-xl border border-white/10 bg-navy-light p-2 shadow-2xl">
                {NAV_AREE.map((l) => (
                  <Link
                    key={l.path}
                    to={l.path}
                    data-testid={`nav-aree-${l.path.slice(1)}`}
                    className="block rounded-lg px-4 py-2.5 text-sm text-slate-200 transition-colors hover:bg-white/5 hover:text-gold-light"
                  >
                    {l.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
          {NAV_MAIN.filter((l) => !l.path.startsWith("/diritto")).map((l) => (
            <NavLink key={l.path} to={l.path} data-testid={`nav-link-${l.path.slice(1)}`} className={linkClass}>
              {l.name}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <BookCta compact testId="header-cta-book" />
          <button
            type="button"
            data-testid="mobile-menu-button"
            onClick={() => setOpen(true)}
            className="rounded-full p-2 text-white transition-colors hover:bg-white/10 lg:hidden"
            aria-label="Apri il menu"
            aria-expanded={open}
          >
            <Menu size={22} />
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-nav" className="fixed inset-0 z-50 flex flex-col bg-navy lg:hidden">
          <div className="container-site flex h-16 items-center justify-between">
            <span className="font-serif text-lg font-semibold text-gold">Menu</span>
            <button
              type="button"
              data-testid="mobile-menu-close"
              onClick={() => setOpen(false)}
              className="rounded-full p-2 text-white transition-colors hover:bg-white/10"
              aria-label="Chiudi il menu"
            >
              <X size={24} />
            </button>
          </div>
          <nav className="container-site flex-1 overflow-y-auto py-6" aria-label="Navigazione mobile">
            <Link
              to="/"
              data-testid="mobile-nav-link-home"
              onClick={() => setOpen(false)}
              className="block border-b border-white/10 py-4 font-serif text-xl text-white"
            >
              Home
            </Link>
            {[...NAV_AREE, ...NAV_MAIN.filter((l) => !l.path.startsWith("/diritto"))].map((l) => (
              <Link
                key={l.path}
                to={l.path}
                data-testid={`mobile-nav-link-${l.path.slice(1)}`}
                onClick={() => setOpen(false)}
                className={`block border-b border-white/10 py-4 font-serif text-xl transition-colors ${
                  location.pathname === l.path ? "text-gold-light" : "text-white"
                }`}
              >
                {l.name}
              </Link>
            ))}
            <div className="py-6">
              <BookCta testId="mobile-cta-book" />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
